import * as React from 'react';
import cx from 'classnames';
import wrapStore from '@src/utils/wrap-store';
import Link from '@src/components/link';
import useAnchorScrollSpy from '@src/utils/hooks/use-anchor-scroll-spy';
import ComponentStore from './store';
const styles = require('./index.less');

// 顶部/侧栏锚点导航目标 = CMS 正文内写死的小节 id（顺序与导航项一致）
// TODO: 锚点 id 依赖 CMS 正文内的 id，须与本届真实 CMS 内容一致（占位期可能不匹配）
const ANCHORS = ['百万绑金', '预创角色', '关注领码', '随机免单', '领6技能同伴', '送黄金套', '十大风云', '虎虎生威', '加速成长', '多重好礼'];

// 背景与公共组件导航已上提到 list 页统一渲染，内页只负责自身锚点导航 + CMS 正文
const ReserveServer = ({ store, className }) => {
  store.use();
  const { activeAnchor, showSidebar, scrollToAnchor, scrollToTop } = useAnchorScrollSpy(ANCHORS);

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.group1} data-name={'预约新服内页'}>
        <div className={styles.group2} data-name={'内容'}>
          <div className={cx(styles.group3, styles.fadeInDown)} data-name={'cms主体内容区'}>
            {/* 单篇 CMS HTML，内含写死 id 锚点小节，由 store 归一化输出 contentHtml */}
            <div className={styles.layer2} data-name={'cms内容'} dangerouslySetInnerHTML={{ __html: store.contentHtml }} />
          </div>
          <div className={cx(styles.group4, styles.fadeInUp)} data-name={'顶部导航条'}>
            <div className={styles.layer3} data-name={'顶部导航标题'} />
            <div className={styles.group5} data-name={'顶部导航按钮'}>
              <div className={styles.layer4} data-name={'按钮组背景'} />
              <div className={styles.group6} data-name={'按钮组list'}>
                <Link
                  className={cx(styles.group7, { [styles.active]: activeAnchor === '百万绑金' })}
                  data-name={'百万绑金'}
                  onClick={() => scrollToAnchor('百万绑金')}
                >
                  <div className={styles.layer5} data-name={'百万绑金-常态'} />
                  <div className={styles.layer6} data-name={'百万绑金-选中/悬停'} />
                </Link>
                <Link
                  className={cx(styles.group8, { [styles.active]: activeAnchor === '预创角色' })}
                  data-name={'预创角色'}
                  onClick={() => scrollToAnchor('预创角色')}
                >
                  <div className={styles.layer7} data-name={'预创角色-常态'} />
                  <div className={styles.layer8} data-name={'预创角色-选中/悬停'} />
                </Link>
                <Link
                  className={cx(styles.group9, { [styles.active]: activeAnchor === '关注领码' })}
                  data-name={'关注领码'}
                  onClick={() => scrollToAnchor('关注领码')}
                >
                  <div className={styles.layer9} data-name={'关注领码-常态'} />
                  <div className={styles.layer10} data-name={'关注领码-选中/悬停'} />
                </Link>
                <Link
                  className={cx(styles.group10, { [styles.active]: activeAnchor === '随机免单' })}
                  data-name={'随机免单'}
                  onClick={() => scrollToAnchor('随机免单')}
                >
                  <div className={styles.layer11} data-name={'随机免单-常态'} />
                  <div className={styles.layer12} data-name={'随机免单-选中/悬停'} />
                </Link>
                <Link
                  className={cx(styles.group11, { [styles.active]: activeAnchor === '领6技能同伴' })}
                  data-name={'领6技能同伴'}
                  onClick={() => scrollToAnchor('领6技能同伴')}
                >
                  <div className={styles.layer13} data-name={'领6技能同伴-常态'} />
                  <div className={styles.layer14} data-name={'领6技能同伴-选中/悬停'} />
                </Link>
                <Link
                  className={cx(styles.group12, { [styles.active]: activeAnchor === '送黄金套' })}
                  data-name={'送黄金套'}
                  onClick={() => scrollToAnchor('送黄金套')}
                >
                  <div className={styles.layer15} data-name={'送黄金套-常态'} />
                  <div className={styles.layer16} data-name={'送黄金套-选中/悬停'} />
                </Link>
                <Link
                  className={cx(styles.group13, { [styles.active]: activeAnchor === '十大风云' })}
                  data-name={'十大风云'}
                  onClick={() => scrollToAnchor('十大风云')}
                >
                  <div className={styles.layer17} data-name={'十大风云-常态'} />
                  <div className={styles.layer18} data-name={'十大风云-选中/悬停'} />
                </Link>
                <Link
                  className={cx(styles.group14, { [styles.active]: activeAnchor === '虎虎生威' })}
                  data-name={'虎虎生威'}
                  onClick={() => scrollToAnchor('虎虎生威')}
                >
                  <div className={styles.layer19} data-name={'虎虎生威-常态'} />
                  <div className={styles.layer20} data-name={'虎虎生威-选中/悬停'} />
                </Link>
                <Link
                  className={cx(styles.group15, { [styles.active]: activeAnchor === '加速成长' })}
                  data-name={'加速成长'}
                  onClick={() => scrollToAnchor('加速成长')}
                >
                  <div className={styles.layer21} data-name={'加速成长-常态'} />
                  <div className={styles.layer22} data-name={'加速成长-选中/悬停'} />
                </Link>
                <Link
                  className={cx(styles.group16, { [styles.active]: activeAnchor === '多重好礼' })}
                  data-name={'多重好礼'}
                  onClick={() => scrollToAnchor('多重好礼')}
                >
                  <div className={styles.layer23} data-name={'多重好礼-常态'} />
                  <div className={styles.layer24} data-name={'多重好礼-选中/悬停'} />
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className={cx(styles.group17, { [styles.visible]: showSidebar })} data-name={'右侧侧栏导航'}>
          <div className={styles.layer25} data-name={'侧栏背景'} />
          <div className={styles.group18} data-name={'侧栏按钮组'}>
            <Link
              className={cx(styles.group19, { [styles.active]: activeAnchor === '百万绑金' })}
              data-name={'百万绑金'}
              onClick={() => scrollToAnchor('百万绑金')}
            >
              <div className={styles.layer26} data-name={'百万绑金-常态'} />
              <div className={styles.layer27} data-name={'百万绑金-选中/悬停'} />
            </Link>
            <Link
              className={cx(styles.group20, { [styles.active]: activeAnchor === '预创角色' })}
              data-name={'预创角色'}
              onClick={() => scrollToAnchor('预创角色')}
            >
              <div className={styles.layer28} data-name={'预创角色-常态'} />
              <div className={styles.layer29} data-name={'预创角色-选中/悬停'} />
            </Link>
            <Link
              className={cx(styles.group21, { [styles.active]: activeAnchor === '关注领码' })}
              data-name={'关注领码'}
              onClick={() => scrollToAnchor('关注领码')}
            >
              <div className={styles.layer30} data-name={'关注领码-常态'} />
              <div className={styles.layer31} data-name={'关注领码-选中/悬停'} />
            </Link>
            <Link
              className={cx(styles.group22, { [styles.active]: activeAnchor === '随机免单' })}
              data-name={'随机免单'}
              onClick={() => scrollToAnchor('随机免单')}
            >
              <div className={styles.layer32} data-name={'随机免单-常态'} />
              <div className={styles.layer33} data-name={'随机免单-选中/悬停'} />
            </Link>
            <Link
              className={cx(styles.group23, { [styles.active]: activeAnchor === '领6技能同伴' })}
              data-name={'领6技能同伴'}
              onClick={() => scrollToAnchor('领6技能同伴')}
            >
              <div className={styles.layer34} data-name={'领6技能同伴-常态'} />
              <div className={styles.layer35} data-name={'领6技能同伴-选中/悬停'} />
            </Link>
            <Link
              className={cx(styles.group24, { [styles.active]: activeAnchor === '送黄金套' })}
              data-name={'送黄金套'}
              onClick={() => scrollToAnchor('送黄金套')}
            >
              <div className={styles.layer36} data-name={'送黄金套-常态'} />
              <div className={styles.layer37} data-name={'送黄金套-选中/悬停'} />
            </Link>
            <Link
              className={cx(styles.group25, { [styles.active]: activeAnchor === '十大风云' })}
              data-name={'十大风云'}
              onClick={() => scrollToAnchor('十大风云')}
            >
              <div className={styles.layer38} data-name={'十大风云-常态'} />
              <div className={styles.layer39} data-name={'十大风云-选中/悬停'} />
            </Link>
            <Link
              className={cx(styles.group26, { [styles.active]: activeAnchor === '虎虎生威' })}
              data-name={'虎虎生威'}
              onClick={() => scrollToAnchor('虎虎生威')}
            >
              <div className={styles.layer40} data-name={'虎虎生威-常态'} />
              <div className={styles.layer41} data-name={'虎虎生威-选中/悬停'} />
            </Link>
            <Link
              className={cx(styles.group27, { [styles.active]: activeAnchor === '加速成长' })}
              data-name={'加速成长'}
              onClick={() => scrollToAnchor('加速成长')}
            >
              <div className={styles.layer42} data-name={'加速成长-常态'} />
              <div className={styles.layer43} data-name={'加速成长-选中/悬停'} />
            </Link>
            <Link
              className={cx(styles.group28, { [styles.active]: activeAnchor === '多重好礼' })}
              data-name={'多重好礼'}
              onClick={() => scrollToAnchor('多重好礼')}
            >
              <div className={styles.layer44} data-name={'多重好礼-常态'} />
              <div className={styles.layer45} data-name={'多重好礼-选中/悬停'} />
            </Link>
            <Link className={styles.group29} data-name={'返回顶部'} onClick={scrollToTop}>
              <div className={styles.layer46} data-name={'返回顶部-常态'} />
              <div className={styles.layer47} data-name={'返回顶部-选中/悬停'} />
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default wrapStore(ReserveServer, ComponentStore);
